import React from "react";
import { Control } from "react-redux-form";
import PendingButton from "components/common/PendingButton";
import { Trans } from "react-i18next";

export const SubmitButton = ({ model = "local", children, ...props }) => {
  return (
    <Control.custom
      model={model}
      component={PendingButton}
      mapProps={{
        disabled: (props) => (!props.fieldValue.valid || props.disabled),
        pending: (props) => props.fieldValue.pending,
      }}
      color="success"
      className={props.className || "" + " mx-0"}
      {...props}
    >
      <Trans>{children}</Trans>
    </Control.custom>
  );
};

export default SubmitButton;
